import './chat.scss';
import React, { useEffect, useState, useRef } from "react";
import { Popup, Button, Input, Toast } from 'react-vant';
import { Select, Drawer, message, Dropdown, Modal,Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
const { Option } = Select;
import { wsUrl, httpUrl } from '../../utils/apiService';
import WebSocketClient from "../../utils/websocket";
import ConnectionLoading from "./connection.js";
import Hello from './hello/hello.js';
import User from './userMessage/user.js';
import UserInfo from './userMessage/userInfo.js';
import Ai from './aiMessage/ai.js';
import Loading from './loadingMessage/loading.js'
import WhatsApp from './aiMessage/whatsapp.js';
import BirthplacePop from './birthplacePop.js';
import ZodiacImage from './aiMessage/zodiacImage.js';
import SendEmailPop from './sendEmailPop.js';
import GoodsMessage from './goodsMessage/GoodsMessage.js';
import FillInformation from './fillInformation.js';
import whatsApp from '../../assets/update_new/whatsapp_logo_green.svg'
const newChatLogo = require('../../assets/update_new/new_chat_logo.png')
import appDownLoad from '../../assets/update_new/app_download_logo.svg'
const newChatSend = require('../../assets/update_new/new_chat_send.png')
import arrowBottom from '../../assets/update_new/icon_bottom_arrow.svg'
import drawerIcon from '../../assets/update_new/icon_drawer_.svg'
import psychicYes from '../../assets/update_new/icon_psychic_checked.svg'
import psychicNo from '../../assets/update_new/icon_psychic_nochecked.svg'
import psychicMore from '../../assets/update_new/icon_psychic_more.svg'
//占卜师数据本地
const psychicData = [
    { psychic_id: '1', psychic_name: 'Mary', psychic_avatar: require('../../assets/pyschicImage/psychic_head_1.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_1.png') },
    { psychic_id: '2', psychic_name: 'Selene', psychic_avatar: require('../../assets/pyschicImage/psychic_head_2.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_2.png') },
    { psychic_id: '3', psychic_name: 'Aino', psychic_avatar: require('../../assets/pyschicImage/psychic_head_3.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_3.png') },
    { psychic_id: '4', psychic_name: 'Sakura', psychic_avatar: require('../../assets/pyschicImage/psychic_head_4.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_4.png') },
    { psychic_id: '5', psychic_name: 'Lia', psychic_avatar: require('../../assets/pyschicImage/psychic_head_5.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_5.png') },
    { psychic_id: '6', psychic_name: 'Terra', psychic_avatar: require('../../assets/pyschicImage/psychic_head_6.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_6.png') },
    { psychic_id: '7', psychic_name: 'Luna', psychic_avatar: require('../../assets/pyschicImage/psychic_head_7.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_7.png') },
    { psychic_id: '8', psychic_name: 'Astra', psychic_avatar: require('../../assets/pyschicImage/psychic_head_8.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_8.png') },
];
//websocket连接 参数
let webSocket = null;
let session_id = '';
let user_id = '';
let user_name = '';
let user_age = '';
let user_gender = '';
let birthday = '';
let user_avatar = '';
let birthplace = '';
let bot_name = 'ZodiacFortuneTeller';//“ChineseFortuneTeller”“TarotFortuneTeller”
let sku_id = ',,';
let motive = '';
let preference_tags = '';
let first_message = 'true';
let language_type = '英语';
let ad_sid = '';
let psychicId = '0';
let intervalId = null; // 定时器 ID
//websocket错误重连
let RECONNECTATTEMPTS = 0//当前重连次数
let MAX_RECONNECT_ATTEMPTS = 5;//最大重连次数
let RECONNECT_INTERVAL = 5000;//重连时间
//连接webscoket loading
let connection_loading = true;

let messageQueue = []; // 消息队列
let isProcessing = false; // 是否正在处理消息
const delay = 50; // 消息处理延迟时间 ms

let isFill_in = false; // 是否是填写信息阶段
let isSendMessage = true; //当前是否有内容输出是否可以发送消息

//是否第一个end=false的文本
let count = 0; // 计数器
//消息
let newMessage; // 新消息

let defaultImg = require("../../assets/update_new/ai_bot_avator.png");

let emailBash = ''; //用于获取命理报告的bash

const Chat = () => {
    const [psychicAvatar, setPsychicAvatar] = useState(defaultImg);
    const [psychicName, setPsychicName] = useState('Sophia');
    const [psychicBackground, setPsychicBackground] = useState('');
    const [isHelloView, setIsHelloView] = useState(true);
    const [isShowWhatsApp, setIsShowWhatsApp] = useState(false);
    const [messagelist, setMessagelist] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const messagesContainerRef = useRef(null);
    const [birthplaceStatus, setbirthplaceStatus] = useState(false);
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [lat, setLat] = useState('');
    const [long, setLong] = useState('');
    const [emailPopStatus, setEmailPopStatus] = useState(false);
    const [email, setEmail] = useState('');
    const [isShowFillInInformation, setIsShowFillInInformation] = useState(false);
    const [isShowSuccessEmail, setisShowSuccessEmail] = useState(false)
    const [isShowChangePsychic, setIsShowChangePsychic] = useState(false)
    const [psychicMessageList, setPsychicMessageList] = useState([]);
    const [isShowDrawer, setIsShowDrawer] = useState(false);
    let startY = 0; // 用于存储触摸点的初始位置

    // 触摸开始事件处理函数
    const handleTouchStart = (event) => {
        // 获取触摸点的初始位置
        startY = event.touches[0].clientY;
    };

    // 触摸移动事件处理函数
    const handleTouchMove = (event) => {
        const chatContent = messagesContainerRef.current;
        if (!chatContent) return;
        // 获取当前触摸点的位置
        const currentY = event.touches[0].clientY;
        // 计算下拉的距离
        const pullDistance = currentY - startY;

        // 如果下拉距离大于 0，并且容器在顶部
        if (pullDistance > 0 && chatContent.scrollTop <= 0) {
            // 阻止浏览器的下拉刷新行为
            if (event.cancelable) {
                event.preventDefault();
            }
            const dampingDistance = pullDistance / 5; // 根据滑动距离计算阻尼距离
            chatContent.style.transition = 'transform 0.3s ease-out';
            chatContent.style.transform = `translate3d(0px, ${dampingDistance}px, 0px)`;
        }

        // 如果上拉距离小于 0，并且容器在底部
        if (pullDistance < 0 && chatContent.scrollHeight - chatContent.scrollTop <= chatContent.clientHeight + 5) {
            // 阻止浏览器的默认行为
            if (event.cancelable) {
                event.preventDefault();
            }
            const dampingDistance = pullDistance / 5; // 根据滑动距离计算阻尼距离
            chatContent.style.transition = 'transform 0.3s ease-out';
            chatContent.style.transform = `translate3d(0px, ${dampingDistance}px, 0px)`;
        }
    };

    // 触摸结束事件处理函数
    const handleTouchEnd = () => {
        const chatContent = messagesContainerRef.current;
        if (chatContent) {
            chatContent.style.transition = 'transform 0.3s ease-out'; // 过渡效果
            chatContent.style.transform = 'translate3d(0px, 0px, 0px)'; // 恢复原始位置
        }
    };

    useEffect(() => {
        const container = messagesContainerRef.current;
        if (container) {
            // 添加事件监听器
            container.addEventListener('touchstart', handleTouchStart, { passive: false } );
            container.addEventListener('touchmove', handleTouchMove, { passive: false });
            container.addEventListener('touchend', handleTouchEnd);
        }

        // 清理事件监听器
        return () => {
            if (container) {
                container.removeEventListener('touchstart', handleTouchStart);
                container.removeEventListener('touchmove', handleTouchMove);
                container.removeEventListener('touchend', handleTouchEnd);
            }
        };
    }, []);

    useEffect(() => {
        // 获取所有 localStorage 的键
        const allKeys = Object.keys(localStorage);
        // 过滤出以 'storageMessage_' 开头的键
        const psychicKeys = allKeys.filter(key => key.startsWith('storageMessage_'));
        // 读取对应的值
        const psychicMessages = psychicKeys.map(key => ({
            id: key
        }));
        // 创建一个存储结果的数组
        const psychicList = [];
        // 遍历 psychicMessages 中的每个消息
        psychicMessages.forEach(message => {
            // message 的格式是 'storageMessage_{psychicId}'
            const psychicId = message.id.split('_')[1]; // 提取 psychicId
            // 在 psychicData 中找到对应的 psychic
            const psychicInfo = psychicData.find(psychic => psychic.psychic_id === psychicId);
            // 如果找到了匹配的 psychic，添加到 psychicList 中
            if (psychicInfo) {
                psychicList.push({
                    psychic_id: psychicInfo.psychic_id,
                    psychic_name: psychicInfo.psychic_name,
                    psychic_avatar: psychicInfo.psychic_avatar,
                });
            }
        });

        //获取独立站传来的占卜师id 根据占卜师id 获取本地占卜师对应信息
        const queryParams = new URLSearchParams(window.location.search);
        const aaidValue = queryParams.get('a_aid');

        // 如果 aaidValue 是 0 或者没有，则设置默认值
        if (!aaidValue || aaidValue === '0') {
            psychicList.unshift({
                psychic_id: '0',
                psychic_name: 'Sophia',
                psychic_avatar: defaultImg,
            });
        } else {
            // 检查 aaidValue 是否在 psychicList 中
            const existingPsychic = psychicList.find(psychic => psychic.psychic_id === aaidValue);
            if (existingPsychic) {
                // 如果存在，则将该条目移动到开头
                psychicList.splice(psychicList.indexOf(existingPsychic), 1); // 移除该项
                psychicList.unshift(existingPsychic); // 添加到开头
            } else {
                // 如果不存在，则在 psychicData 中查找对应的 psychic
                const newPsychicInfo = psychicData.find(psychic => psychic.psychic_id === aaidValue);
                if (newPsychicInfo) {
                    // 添加新的条目到开头
                    psychicList.unshift({
                        psychic_id: newPsychicInfo.psychic_id,
                        psychic_name: newPsychicInfo.psychic_name,
                        psychic_avatar: newPsychicInfo.psychic_avatar,
                    });
                }
            }
        }
        // 更新 state
        setPsychicMessageList(psychicList);

        const email = queryParams.get('email');
        setEmail(email)
        if (aaidValue) {
            const psychic = psychicData.find(item => item.psychic_id === aaidValue);
            if (psychic) {
                setPsychicAvatar(psychic.psychic_avatar)
                setPsychicName(psychic.psychic_name)
                setPsychicBackground(psychic.psychic_img)
                psychicId = aaidValue
            }
        }
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            storageData.psychicId = psychicId
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
            session_id = storageData.sessionId || '';
            const loaclMessageList = JSON.parse(storageData.messageList) || [];
            if (loaclMessageList.length > 0) {
                first_message = false;
                setMessagelist(loaclMessageList);
                setIsHelloView(false);
                setTimeout(() => {
                    //如何已经填写过用户信息 直接给用户信息置灰
                    let isFill_in = storageData.isFill_in
                    if (isFill_in) {
                        // 找到所有具有 pc_FillInfo 类的元素
                        const elements = document.querySelectorAll('.pc_FillInfo');
                        const melements = document.querySelectorAll('.ai_fill_in_information');
                        // 遍历每个元素并设置样式
                        melements.forEach(element => {
                            element.style.pointerEvents = 'none'; // 禁用鼠标事件
                            element.style.opacity = '0.8'; // 可选：使元素看起来是禁用状态
                        });
                        elements.forEach(element => {
                            element.style.pointerEvents = 'none'; // 禁用鼠标事件
                            element.style.opacity = '0.5'; // 可选：使元素看起来是禁用状态
                        });
                    }
                    scrollToBottom();
                }, 1500)
            } else {
                first_message = true;
            }
        } else {
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify({ 'psychicId': psychicId }))
        }

        startWebSocket();

        return () => {
            stopProcessing();
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            scrollToBottom();
            uploadCache();
        }, 500)
    }, [messagelist]);

    //开始连接ws
    const startWebSocket = () => {
        const queryParams = new URLSearchParams({
            session_id: session_id,
            user_id: user_id,
            user_name: user_name,
            user_age: user_age,
            user_gender: user_gender,
            birthday: birthday,
            user_avatar: user_avatar,
            birthplace: birthplace,
            bot_name: bot_name,
            sku_id: sku_id,
            motive: motive,
            preference_tags: preference_tags,
            first_message: first_message,
            language_type: language_type,
            ad_sid: ad_sid,
            psychic_id: psychicId,
        });
        webSocket = new WebSocketClient(`${wsUrl}?${queryParams.toString()}`);
        webSocket.onOpen = () => {
            console.log('WebSocket onOpen.');
            //连接成功 重置连接次数
            RECONNECTATTEMPTS = 0;
        }
        webSocket.onMessage = (data) => {
            try {
                const messageData = JSON.parse(data);
                //如果当前到了选择用户信息阶段 用一个字段来表示当前状态
                if (messageData.code == 2001) {
                    isFill_in = true;
                }
                messageQueue.push(messageData);
                // 如果没有正在处理消息，则开始处理队列
                if (!isProcessing) {
                    processMessageQueue();
                }
            } catch (error) {
                console.error('Error processing message:', error);
            }
        }
        webSocket.onClose = () => {
            console.log('WebSocket OnClose.');
        };
        webSocket.onError = (error) => {
            console.error('WebSocket Error:', error);
            isSendMessage = true
            //连接错误 关闭loading
            if (connection_loading) {
                const loadingElement = document.querySelector('.connection_loading');
                if (loadingElement) {
                    loadingElement.style.display = 'none';
                }
                connection_loading = false;
            }
            //连接错误 重新连接
            if (webSocket) {
                if (RECONNECTATTEMPTS < MAX_RECONNECT_ATTEMPTS) {
                    console.log(`Reconnecting in ${RECONNECT_INTERVAL} milliseconds...`);
                    setTimeout(() => {
                        RECONNECTATTEMPTS = RECONNECTATTEMPTS + 1;
                        startWebSocket();
                    }, RECONNECT_INTERVAL);
                } else {
                    console.log('Max reconnect attempts reached. Stop reconnecting.');
                }
            }
        }
        webSocket.connect();
    }
    //处理消息队列
    const processMessageQueue = () => {
        if (messageQueue.length === 0) {
            isProcessing = false;
            return;
        }
        isProcessing = true;
        const messageData = messageQueue.shift();
        try {
            handleMessage(messageData);
        } catch (error) {
            console.error('Error handling message:', error);
        }
        // 继续处理下一个消息，或者等待下一个定时器触发
        intervalId = setTimeout(processMessageQueue, delay);
    }
    const stopProcessing = () => {
        clearTimeout(intervalId);
        isProcessing = false;
        messageQueue = [];
    }
    //处理消息
    const handleMessage = (messageData) => {
        const { code, end, type, content } = messageData;
        if (type == 'string' || type == 'hide' || type == 'again') {
            if (connection_loading) {
                const loadingElement = document.querySelector('.connection_loading');
                if (loadingElement) {
                    loadingElement.style.display = 'none';
                }
                connection_loading = false;
            }
        }
        if (end == false) {
            isSendMessage = false;
            setSendImgStyle()
        } else if (end == true) {
            isSendMessage = true;
            restoreSendImgStyle()
        }

        switch (type) {
            case 'hello':
                setIsHelloView(true);
                break;
            case 'again':
                setIsHelloView(false);

                break;
            case 'session_id':
                session_id = messageData.session_id;
                bot_name = messageData.bot_name;
                const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
                if (storageMessage) {
                    const storageData = JSON.parse(storageMessage);
                    if (storageData.sessionId) {
                        if (storageData.sessionId != session_id) {
                            localStorage.removeItem('storageMessage_' + psychicId)
                            const data = {
                                'psychicId': psychicId,
                                'sessionId': session_id
                            }
                            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(data))
                            setMessagelist([]); // 清空消息列表
                        }
                    } else {
                        storageData.sessionId = session_id
                        localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData));
                    }
                }
                break;
            case 'string':
                if (end == true) {
                    if (count == 0) {
                        const AiMessage = {
                            isUser: false,
                            type: type,
                            end: end,
                            code: code,
                            sessionId: messageData.session_id,
                            showCursor: end,
                            content: content,
                            botName: messageData.bot_name,
                        }
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                                updatedMessages.pop();
                            }
                            return [...updatedMessages, AiMessage];
                        });
                    } else {
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            const lastMessageIndex = updatedMessages.length - 1;

                            if (lastMessageIndex >= 0) {
                                updatedMessages[lastMessageIndex].end = end;
                            }
                            return updatedMessages;
                        });
                        count = 0;
                        newMessage = '';
                    }
                } else if (end == false) {
                    if (newMessage) {
                        newMessage += content; // 将消息内容添加到新消息中
                    } else {
                        newMessage = content; // 否则设置新消息内容
                    }
                    if (count == 0) {
                        const AiMessage = {
                            isUser: false,
                            type: type,
                            end: end,
                            code: code,
                            sessionId: messageData.session_id,
                            showCursor: end,
                            content: newMessage,
                            botName: messageData.bot_name,
                        }
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                                updatedMessages.pop();
                            }
                            return [...updatedMessages, AiMessage];
                        });
                        count++;
                    } else if (count > 0) {
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            const lastMessageIndex = updatedMessages.length - 1;

                            if (lastMessageIndex >= 0) {
                                updatedMessages[lastMessageIndex].content = newMessage;
                            }
                            return updatedMessages;
                        });
                    }
                }
                break;
            case 'hide':
                if (end == true) {
                    if (count == 0) {
                        const AiMessage = {
                            isUser: false,
                            type: type,
                            end: end,
                            code: code,
                            sessionId: messageData.session_id,
                            showCursor: end,
                            content: content,
                            botName: messageData.bot_name,
                        }
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                                updatedMessages.pop();
                            }
                            return [...updatedMessages, AiMessage];
                        });
                    } else {
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            const lastMessageIndex = updatedMessages.length - 1;

                            if (lastMessageIndex >= 0) {
                                updatedMessages[lastMessageIndex].end = end;
                            }
                            return updatedMessages;
                        });
                        count = 0;
                        newMessage = '';
                    }
                } else if (end == false) {
                    if (newMessage) {
                        newMessage += content; // 将消息内容添加到新消息中
                    } else {
                        newMessage = content; // 否则设置新消息内容
                    }
                    if (count == 0) {
                        const AiMessage = {
                            isUser: false,
                            type: type,
                            end: end,
                            code: code,
                            sessionId: messageData.session_id,
                            showCursor: end,
                            content: newMessage,
                            botName: messageData.bot_name,
                        }
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                                updatedMessages.pop();
                            }
                            return [...updatedMessages, AiMessage];
                        });
                        count++;
                    } else if (count > 0) {
                        setMessagelist((prevMessages) => {
                            const updatedMessages = [...prevMessages];
                            const lastMessageIndex = updatedMessages.length - 1;

                            if (lastMessageIndex >= 0) {
                                updatedMessages[lastMessageIndex].content = newMessage;
                            }
                            return updatedMessages;
                        });
                    }
                }
                break;
            case 'sku':
                const GoodsMessage = {
                    isUser: false,
                    type: type,
                    content: content,
                }
                setMessagelist((prevMessages) => {
                    const updatedMessages = [...prevMessages];
                    if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                        updatedMessages.pop();
                    }
                    return [...updatedMessages, GoodsMessage];
                });
                break;
            case 'star_pic':
                const AiMessage = {
                    isUser: false,
                    type: type,
                    end: end,
                    code: code,
                    sessionId: messageData.session_id,
                    showCursor: end,
                    content: content,
                    botName: messageData.bot_name,
                }
                setMessagelist((prevMessages) => {
                    const updatedMessages = [...prevMessages];
                    if (updatedMessages.length > 0 && updatedMessages[updatedMessages.length - 1].type === 'loading') {
                        updatedMessages.pop();
                    }
                    return [...updatedMessages, AiMessage];
                });
                break;
        }
    }
    //滚动到底部
    const scrollToBottom = () => {
        const container = messagesContainerRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight; // 快速滚动到底部
        }
        // const container = messagesContainerRef.current;
        // if (container) {
        //     const targetScrollTop = container.scrollHeight;
        //     const startScrollTop = container.scrollTop;
        //     const distance = targetScrollTop - startScrollTop;
        //     const duration = 300; // 动画持续时间，单位为毫秒
        //     let startTime = null;

        //     const animation = (currentTime) => {
        //         if (startTime === null) startTime = currentTime;
        //         const timeElapsed = currentTime - startTime;
        //         const progress = Math.min(timeElapsed / duration, 1); // 确保值在 0 到 1 之间

        //         // 使用缓动函数计算当前滚动位置
        //         const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        //         const scrollPosition = startScrollTop + distance * easeInOutQuad(progress);

        //         container.scrollTop = scrollPosition;

        //         if (progress < 1) {
        //             requestAnimationFrame(animation);
        //         }
        //     };

        //     requestAnimationFrame(animation);
        // }
    };
    //点击招呼页面开始聊天
    const hellowStart = () => {
        setIsHelloView(false)
    }
    //跳转WhatsApp
    const startWhatsApp = () => {
        window.open("https://wa.me/886966427755", '_blank');
    }
    //打开whatsapp弹窗
    const showWhatsAppDialog = () => {
        setIsShowWhatsApp(true)
    }
    //关闭whatsapp弹窗
    const hideWhatsAppDialog = () => {
        setIsShowWhatsApp(false)
    }
    //点击打开信息选择
    const toggleFillInformation = () => {
        setIsShowFillInInformation(prev => !prev);
    }
    //点击消息发送按钮
    const handleSend = () => {
        if (isFill_in) {
            const messages = document.getElementsByClassName('ai_content');
            if (messages.length > 0) {
                const lastMessage = messages[messages.length - 1];
                lastMessage.classList.remove('slide-in-left');
                lastMessage.classList.add('animationInfoTips');
                // 可选：在动画结束后移除 `animated` 类
                setTimeout(() => {
                    lastMessage.classList.remove('animationInfoTips');
                }, 1200); // 动画持续时间
            }
            return
        }
        if (inputValue.trim()) {
            sendMessage(inputValue)
            setInputValue('');
        }
    };
    //监听回车键发送消息
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSend();
        }
    };
    //发送消息
    const sendMessage = (message) => {
        //当前有内容正在输出 不能发送消息
        if (isSendMessage == false) {
            return
        }
        isSendMessage = false
        //是否已达三轮对话限制 
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            if (storageData.chatTurnCount && storageData.chatTurnCount >= 3) {
                isSendMessage = true
                const userMessage = {
                    isUser: true,
                    content: message,
                    type: 'string',
                };
                const whatsMessage = {
                    isUser: false,
                    type: 'whatsApp',
                    content: 'This product is the best solution for your current problem. If you have further questions, contact our professionals.',
                }
                setMessagelist((prevMessages) => [...prevMessages, userMessage, whatsMessage]);
                return
            }
        }
        const userMessage = {
            isUser: true,
            content: message,
            type: 'string',
        };
        const loadingMessage = {
            isUser: false,
            loadingText: "replying...",
            type: 'loading',
        }
        setMessagelist((prevMessages) => [...prevMessages, userMessage, loadingMessage]);
        webSocket.send(message);

        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            if (storageData.chatTurnCount) {
                storageData.chatTurnCount = storageData.chatTurnCount + 1
            } else {
                storageData.chatTurnCount = 1
            }
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
        }
    }
    //点击pc端选择出生地
    const clickBirthPlace = (e) => {
        setbirthplaceStatus(e);
    }
    //点击pc端 出生地显示回调
    const clickBirthplaceStatus = (e) => {
        setbirthplaceStatus(e);
    }
    //接受出生地回调
    const countryCallback = (e) => {
        setCountry(e);
    }
    const cityCallback = (e) => {
        setCity(e);
    }
    const latCallback = (e) => {
        setLat(e);
    }
    const longCallback = (e) => {
        setLong(e);
    }

    //提交pc端 用户信息
    const confirmInfoData = (e) => {
        isSendMessage = false
        //是否已达三轮对话限制 提示仅测算一次 跳出
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            if (storageData.chatTurnCount && storageData.chatTurnCount >= 3) {
                message.info("Single calculations only. Contact customer service for custom options.")
                return
            }
        }
        user_gender = e.gender;
        birthday = e.birthday;
        birthplace = city;

        const userMessage = {
            gender: e.gender,
            bloodType: e.bloodType,
            birthday: e.birthday,
            isUser: true,
            type: 'info',
        };
        const loadingMessage = {
            isUser: false,
            type: 'loading',
            botName: bot_name,
            loadingText: psychicName + '  is aligning your stars....'
        };
        setMessagelist((prevMessages) => [...prevMessages, userMessage, loadingMessage]);

        //发送给后端
        const userINFO = {
            user_id: user_id,
            user_name: user_name,
            user_age: user_age,
            user_gender: e.gender,
            blood_type: e.bloodType,
            zodiac: '',
            birthday: e.birthday,
            user_avatar: user_avatar,
            birthplace: city,
            lat: lat,
            lng: long,
            preference_tags: preference_tags,
        };
        webSocket.send(JSON.stringify(userINFO));

        isFill_in = false; //重置填写信息阶段状态 可以正常聊天

        // 找到所有具有 pc_FillInfo 类的元素
        const elements = document.querySelectorAll('.pc_FillInfo');
        // 遍历每个元素并设置样式
        elements.forEach(element => {
            element.style.pointerEvents = 'none'; // 禁用鼠标事件
            element.style.opacity = '0.5'; // 可选：使元素看起来是禁用状态
        });
        const melements = document.querySelectorAll('.ai_fill_in_information');
        // 遍历每个元素并设置样式
        melements.forEach(element => {
            element.style.pointerEvents = 'none'; // 禁用鼠标事件
            element.style.opacity = '0.8'; // 可选：使元素看起来是禁用状态
        });
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            if (storageData.chatTurnCount) {
                storageData.chatTurnCount = storageData.chatTurnCount + 1
            } else {
                storageData.chatTurnCount = 1
            }
            storageData.isFill_in = true
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
        }
    }

    //获取命理报告
    const getReport = (bash) => {
        const zodiacReport = localStorage.getItem('zodiacReport')
        if (zodiacReport) {
            setisShowSuccessEmail(true);
            return
        }
        if (isSendMessage == false) {
            return
        }
        emailBash = bash;
        clickEmailPop(true);
    }
    const clickEmailPop = (e) => {
        setEmailPopStatus(e);
    }

    const submitEmail = (e) => {
        const data = {
            email: e,
            md5_hash: emailBash,
        }
        webSocket.send(JSON.stringify(data));
        setisShowSuccessEmail(true);
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            storageData.zodiacReport = true
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
        }
    }

    //选择要测算的问题
    const setCalculationType = (e) => {
        isSendMessage = false
        //已经选择测算类型 提示仅测算一次 跳出
        //是否已达三轮对话限制 
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            if (storageData.isCalculation || storageData.chatTurnCount >= 3) {
                message.info("Single calculations only. Contact customer service for custom options.")
                return
            }
        }
        const userMessage = {
            content: e,
            isUser: true,
            type: 'string',
        };
        const loadingMessage = {
            isUser: false,
            type: 'loading',
            botName: bot_name,
            loadingText: 'Cosmic answers are on the way...'
        };
        setMessagelist((prevMessages) => [...prevMessages, userMessage, loadingMessage]);
        webSocket.send(e)

        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            storageData.isCalculation = true
            if (storageData.chatTurnCount) {
                storageData.chatTurnCount = storageData.chatTurnCount + 1
            } else {
                storageData.chatTurnCount = 1
            }
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
        }
    }

    //上传缓存
    const uploadCache = () => {
        let loaclMessageList = messagelist
        loaclMessageList = loaclMessageList.filter(message => message.type !== "loading");
        while (loaclMessageList.length >= 20) {
            loaclMessageList.shift();
        }
        const storageMessage = localStorage.getItem('storageMessage_' + psychicId)
        if (storageMessage) {
            const storageData = JSON.parse(storageMessage)
            storageData.messageList = JSON.stringify(loaclMessageList)
            storageData.sessionId = session_id
            localStorage.setItem('storageMessage_' + psychicId, JSON.stringify(storageData))
        }
        first_message = false;
    }

    // 设置透明度和不可点击的函数
    const setSendImgStyle = () => {
        const elements = document.querySelectorAll('.send_img');

        elements.forEach(element => {
            if (element.style.opacity !== '0.5') { // 检查透明度是否已设置
                element.style.opacity = '0.5'; // 设置透明度为 50%
                element.style.pointerEvents = 'none'; // 禁用鼠标事件
            }
        });
    };

    // 恢复透明度和可点击状态的函数
    const restoreSendImgStyle = () => {
        const elements = document.querySelectorAll('.send_img');

        elements.forEach(element => {
            if (element.style.opacity !== '1') { // 检查透明度是否已恢复
                element.style.opacity = '1'; // 恢复透明度为 100%
                element.style.pointerEvents = 'auto'; // 恢复鼠标事件
            }
        });
    };

    const updatePsychic = (psychic) => {
        //changePsychic();
        // 获取当前 URL
        const currentUrl = new URL(window.location.href);
        // 设置 a_aid 参数的值为 psychic_id
        currentUrl.searchParams.set('a_aid', psychic.psychic_id);
        // 获取更新后的 URL 字符串
        const newUrl = currentUrl.toString();
        // 重新加载页面
        setTimeout(() => {
            window.location.href = newUrl;
        }, 500)
    }
    const changePsychic = () => {
        if (isShowChangePsychic) {
            setIsShowChangePsychic(false);
        } else {
            setIsShowChangePsychic(true);
        }
    }
    const showDrawer = () => {
        setIsShowDrawer(true)
    }

    const items = [
        {
            label: (
                <span style={{ color: 'red' }}>
                    <DeleteOutlined style={{ marginRight: 8 }} />
                    Delete
                </span>
            ),
            key: '1',
        }
    ];
    const onClickDelete = (psychicId, psychicName) => {
        // 显示确认框
        Modal.confirm({
            title: 'Confirm to delete your chat with "' + psychicName + '" ?',
            content: 'Once deleted, the chat history cannot be recovered',
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                localStorage.removeItem('storageMessage_' + psychicId)
                setPsychicMessageList(prevList => prevList.filter(psychic => psychic.psychic_id !== psychicId));
                message.success(`Deleted chat history with ${psychicName}`);
            },
        });
    };

    return (
        <div id='chat_main'>
            <div className='chat_left'>
                <img src={newChatLogo} className='new_chat_logo' />
                <div className='chat_left_divider'> </div>
                <span className='chat_left_title'>recent conversations</span>
                <div className='chat_left_list'>
                    {psychicMessageList.map((psychic, index) => (
                        <div className={`chat_left_item ${index === 0 ? 'change' : ''}`} key={psychic.psychic_id}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '70%' }} onClick={() => updatePsychic(psychic)}>
                                <img src={psychic.psychic_avatar} alt={psychic.psychic_name} className='psychic_avatar' />
                                <span className='psychic_name'>{psychic.psychic_name}</span>
                            </div>
                            <Dropdown
                                menu={{
                                    items,
                                    onClick: () => onClickDelete(psychic.psychic_id, psychic.psychic_name)
                                }}
                            >
                                <img src={psychicMore} className={`psychic_more ${index === 0 ? 'change' : ''}`} />
                            </Dropdown>
                        </div>
                    ))}
                </div>
                <img className='app_down_load'
                    src={appDownLoad}
                    onClick={() => window.open('https://play.google.com/store/apps/details?id=com.zequan.myapplication', '_blank')} />
            </div>
            <div className='chat_right'>
                {isHelloView && (
                    <Hello
                        messagelist={messagelist}
                        showStatus={hellowStart}
                        helloImage={psychicAvatar}
                    />
                )}
                {!isHelloView && (
                    <div className='chat_container'>
                        <div className='chat_content'>
                            <div className='head_title'>
                                <Select
                                    placeholder="请选择占卜师"
                                    allowClear
                                    onChange={(value) => {
                                        const selected = psychicData.find(psychic => psychic.psychic_id === value);
                                        updatePsychic(selected);
                                    }}
                                    optionLabelProp="label"
                                    open={isShowChangePsychic}
                                    defaultValue={psychicId}
                                >
                                    {psychicData.map(psychic => (
                                        <Option key={psychic.psychic_id} value={psychic.psychic_id} label={psychic.psychic_name}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <img
                                                    src={psychic.psychic_avatar}
                                                    alt={psychic.psychic_name}
                                                    style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 8 }}
                                                />
                                                {psychic.psychic_name}
                                                {psychic.psychic_id === psychicId ? (
                                                    <img
                                                        src={psychicYes} // 确保路径正确
                                                        alt="Selected"
                                                        style={{ width: 19, height: 19, marginLeft: 'auto' }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={psychicNo} // 确保路径正确
                                                        alt="Not Selected"
                                                        style={{ width: 19, height: 19, marginLeft: 'auto' }}
                                                    />
                                                )}
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                                <img src={drawerIcon} className='drawer_icon' onClick={showDrawer} />
                                <div className='change_psychic' onClick={changePsychic}>
                                    <img src={psychicAvatar} className='psychic_avatar' />
                                    <span className='psychic_name'>{psychicName}</span>
                                    <img src={arrowBottom} className='arrow_bottom' />
                                </div>
                                <Tooltip placement="bottom" title={<span>Click for expert help on WhatsApp</span>} arrow={false}>
                                    <img src={whatsApp} className='whatsApp_img' onClick={showWhatsAppDialog} />
                                </Tooltip>
                            </div>
                            <div className='message_chat' ref={messagesContainerRef}>
                                {messagelist.map((item, index) => {
                                    if (item.isUser && item.type === 'string') {
                                        return <User key={index} content={item.content} />;
                                    }
                                    if (item.isUser && item.type === 'info') {
                                        return (
                                            <UserInfo
                                                key={index}
                                                gender={item.gender}
                                                birthday={item.birthday}
                                                bloodType={item.bloodType}
                                            />
                                        );
                                    }
                                    if (!item.isUser && (item.type === 'string' || item.type === 'hide')) {
                                        return <Ai key={index}
                                            avatar={psychicAvatar}
                                            code={item.code}
                                            content={item.content}
                                            showFillInInformation={toggleFillInformation}
                                            clickBirthPlace={clickBirthPlace}
                                            confirmInfoData={confirmInfoData}
                                            country={country}
                                            city={city}
                                            setCalculationType={setCalculationType} />;
                                    }
                                    if (!item.isUser && item.type === 'star_pic') {
                                        return <ZodiacImage key={index}
                                            avator={psychicAvatar}
                                            content={item.content}
                                            getReport={getReport}
                                        />;
                                    }
                                    if (!item.isUser && item.type === 'sku') {
                                        return <GoodsMessage key={index}
                                            content={item.content}
                                            psychicId={psychicId}
                                        />;
                                    }
                                    if (!item.isUser && item.type === 'loading') {
                                        return <Loading key={index}
                                            avator={psychicAvatar}
                                            loading_text={item.loadingText} />;
                                    }
                                    if (!item.isUser && item.type == 'whatsApp') {
                                        return <WhatsApp key={index}
                                            avator={psychicAvatar}
                                            content={item.content}
                                            whatsAppClick={startWhatsApp} />;
                                    }
                                    return null; // 确保所有条件都处理过
                                })}
                            </div>
                            <div className='bottom_input_box'>
                                <div className='bottom_input'>
                                    <Input
                                        className='input_area'
                                        placeholder="I want..."
                                        value={inputValue}
                                        onChange={setInputValue} // 更新输入框的值
                                        onKeyPress={handleKeyPress}
                                    />
                                    <img src={newChatSend} className='send_img'
                                        onClick={handleSend} // 点击发送图标
                                        alt="Send" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Drawer
                closable={false}
                open={isShowDrawer}
                onClose={() => setIsShowDrawer(false)}
                placement={'left'}
                key={'left'}
            >
                <div className='chat_left'>
                    <img src={newChatLogo} className='new_chat_logo' />
                    <div className='chat_left_divider'> </div>
                    <span className='chat_left_title'>recent conversations</span>
                    <div className='chat_left_list'>
                        {psychicMessageList.map((psychic, index) => (
                            <div className={`chat_left_item ${index === 0 ? 'change' : ''}`} key={psychic.psychic_id}>
                                <div style={{ display: 'flex', alignItems: 'center', width: '70%' }} onClick={() => updatePsychic(psychic)}>
                                    <img src={psychic.psychic_avatar} alt={psychic.psychic_name} className='psychic_avatar' />
                                    <span className='psychic_name'>{psychic.psychic_name}</span>
                                </div>
                                <Dropdown
                                    menu={{
                                        items,
                                        onClick: () => onClickDelete(psychic.psychic_id, psychic.psychic_name),
                                    }}
                                >
                                    <img src={psychicMore} className={`psychic_more ${index === 0 ? 'change' : ''}`} />
                                </Dropdown>
                            </div>
                        ))}
                    </div>
                    <img className='app_down_load'
                        src={appDownLoad}
                        onClick={() => window.open('https://play.google.com/store/apps/details?id=com.zequan.myapplication', '_blank')} />
                </div>
            </Drawer>
            {isShowFillInInformation &&
                <FillInformation
                    showFillInformation={setIsShowFillInInformation}
                    confirmInfoData={confirmInfoData}
                    country={country}
                    city={city}
                    clickBirthPlace={clickBirthPlace} />
            }
            <ConnectionLoading />
            <Popup
                visible={isShowWhatsApp}
                className="whatsApp_pop"
                position='center'
                round
                closeOnClickOverlay={false}
            >
                <div className="whatsApp_box">
                    <img className="whatsApp_img" src={whatsApp} />
                    <span className="whatsApp_content">You're about to be redirected to a WhatsApp chat. Do you want to proceed?</span>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
                        <Button className="whatsApp_close" color='#7D7D7D33' type='primary' block onClick={hideWhatsAppDialog}>
                            Cancel
                        </Button>
                        <Button className="whatsApp_cofirm" color='#FFB341' type='primary' block onClick={startWhatsApp}>
                            Confirm
                        </Button>
                    </div>
                </div>
            </Popup>
            <Popup
                visible={isShowSuccessEmail}
                className="email_success"
                position='center'
                round
                onClose={() => setisShowSuccessEmail(false)}
                closeable
            >
                <div className="email_success_box">
                    <span className='email_title'>Success</span>
                    <span className="email_content">Your astrology report has been emailed. Check your inbox!</span>
                    <Button className="email_cofirm" color='#FFB341' type='primary' block onClick={() => setisShowSuccessEmail(false)}>
                        Confirm
                    </Button>
                </div>
            </Popup>
            <SendEmailPop
                emailPopStatus={emailPopStatus}
                emailValue={email}
                clickEmailPop={clickEmailPop}
                submitEmail={submitEmail}
            />
            <BirthplacePop birthplaceStatus={birthplaceStatus}
                clickBirthplaceStatus={clickBirthplaceStatus}
                countryCallback={countryCallback}
                cityCallback={cityCallback}
                latCallback={latCallback}
                longCallback={longCallback} />
        </div>
    )
}
export default Chat;